export default __webpack_public_path__ + "locales/bg/Errors.json?hash=e24ab82913c278109c319c2c7d38e4ef";